
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li *ngFor="let item of items" [class.active]="!item?.url" class="breadcrumb-item">
          <a [routerLink]="item?.url">{{item.title}}</a>
        </li>
      </ol>
    </nav>
  